var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{model:{value:(_vm.activated),callback:function ($$v) {_vm.activated=$$v},expression:"activated"}})
}
var staticRenderFns = []

export { render, staticRenderFns }